<template>
  <div>
    <div v-if="!showMapWarehouse" class="SeekWarehouse-root">
      <a-affix :offset-top="filterWhareTop('top')" :target="() => filterDom()">
        <div class="title-seek">
          <div class="breadcrumb">
            <a-input-search
              v-model="warehouseName"
              v-track-click="{trackName: '寻仓-搜索'}"
              placeholder="请输入仓库名称"
              class="seek-search"
              :max-length="30"
              @search="onSearch"
            />
            <!-- <a  v-track-click="{trackName: '我要寻仓-地图找仓'}" class="map-warehouse" @click="showMapWarehouse = true">
              <span>地图找仓</span>
            </a> -->
            <div v-if="showTotal" class="search-total">
              共找到{{total}}条符合条件的仓库
            </div>
          </div>
          <!-- <div  class="find">
            <span v-track-click="{trackName: '我要寻仓-委托找仓'}" @click="toFindWarehouse">
              <img src="@/assets/img/icon/icon_hire.png" alt="">
              委托找仓
            </span>
            <span @click="toLease">
              <img v-track-click="{trackName: '我要寻仓-我要出租'}" src="@/assets/img/icon/icon_entrust.png" alt="">
              我要出租
            </span>
          </div> -->
        </div>
      </a-affix>
      <div class="query-box">
        <div class="query-list">
          <div class="query-title query-weizhi">仓库位置</div>
          <div style="flex: 1;">
            <div class="query-body">
              <span
                :class="queryListStyle(queryForm.regional === '')"
                @click="handleProvince('regional', '')"
              >
                不限
              </span> 
              <div class="weizhi-list">
                <span
                  v-for="item in regionalList"
                  :key="item.value"
                  :class="queryListStyle(item.value === queryForm.regional)"
                  @click="handleProvince('regional', item.value, item)"
                >
                  {{item.label}}
                </span>
              </div>
            </div>
            <div class="query-body">
              <span
                :class="queryListStyle(queryForm.province === '')"
                @click="handleProvince('province', '')"
              >
                不限
              </span> 
              <div class="weizhi-list">
                <span
                  v-for="item in provinceList"
                  :key="item.code"
                >
                  <span
                    v-if="!queryForm.regional || regionalCityList.includes(item.label)"
                    :class="queryListStyle(item.code === queryForm.province)"
                    @click="handleProvince('province', item.code)"
                  >
                    {{item.label}}
                  </span>
                </span>
              </div>
            </div>
            <div v-if="cityList.length" class="query-body">
              <span
                :class="queryListStyle(queryForm.city === '')"
                @click="handleProvince('city', '')"
              >
                不限
              </span> 
              <div class="weizhi-list">
                <span
                  v-for="item in cityList"
                  :key="item.code"
                  :class="queryListStyle(item.code === queryForm.city)"
                  @click="handleProvince('city', item.code)"
                >
                  {{item.label}}
                </span>
              </div>
            </div>
            <div v-if="regionList.length" class="query-body">
              <span
                :class="queryListStyle(queryForm.region === '')"
                @click="handleProvince('region', '')"
              >
                不限
              </span> 
              <div class="weizhi-list">
                <span
                  v-for="item in regionList"
                  :key="item.code"
                  :class="queryListStyle(item.code === queryForm.region)"
                  @click="handleProvince('region', item.code)"
                >
                  {{item.label}}
                </span>
              </div>
            </div>
          </div>
        </div>
        <div class="query-list">
          <div class="query-title query-wuqu">温区</div>
          <div class="query-body">
            <span
                :class="queryListStyle(!queryForm.warmArea.length)"
                @click="warmChange()"
              >
                不限
            </span> 
            <!-- <a-checkbox-group v-model="queryForm.warmArea" class="checkbox" :options="warmAreaList" @change="warmChange" /> -->
            <span v-for="item in warmAreaList"
                  :key="item.value"
                  :class="queryListStyle(item.value === queryForm.warmArea)"
                  @click="warmChange(item)">{{item.label}}</span>
          </div>
        </div>
        <div class="query-list">
          <div class="query-title query-area">面积</div>
          <div class="query-body">
            <span v-for="(item, index) in areaList"
                  :key="index"
                  :class="queryListStyle(item.label === queryForm.area)"
                  @click="areaChange(item)">{{item.label}}</span>
          </div>
        </div>
        <div class="query-list">
          <div class="query-title query-type">仓库类型</div>
          <div class="query-body">
            <span v-for="item in warehouseList"
                  :key="item.code"
                  :class="queryListStyle(item.code === queryForm.warehouse)"
                  @click="warehouseChange(item)">{{item.name}}</span>
          </div>
        </div>
        <div class="query-list">
          <div class="query-title query-Fire">消防等级</div>
          <div class="query-body">
            <span v-for="item in warehouseFireRating"
              :key="item.code"
              :class="queryListStyle(item.code === queryForm.fireWareLevel)"
              @click="handleChange(item,'fireWareLevel','code')">{{item.name}}</span>
          </div>
        </div>
        <div class="query-list">
          <div class="query-title query-hardware">安保设施</div>
          <div class="query-body">
            <span v-for="item in safeEquipments"
              :key="item.code"
              :class="queryListStyle(item.code === queryForm.safeEquipments)"
              @click="handleChange(item,'safeEquipments','code')">{{item.name}}</span>
          </div>
        </div>
        <div class="query-list">
          <div class="query-title query-yuncang">云仓供应商业务</div>
          <div class="query-body">
            <span v-for="item in yuncangList"
              :key="item.value"
              :class="queryListStyle(item.value === queryForm.isBizService)"
              @click="handleChange(item,'isBizService','value')">{{item.label}}</span>
          </div>
        </div>
      </div>
      <div class="bodyDiv">
        <div class="bodyLeft">
          <div v-if="total" class="body-box">
            <div class="body-content">
              <div
                v-for="(item) in WarehouseInfo"
                :key="item.id"
                class="body-list"
                @click="viewDetail(item.id)"
              >
                <div class="img-box">
                  <img :src="wareImage(item.files)?wareImage(item.files):require('../../assets/img/pic-cangku-default.png')" />
                </div>
                <div class="detail-box">
                  <div class="name">{{nameDispose(item.warehouseSourceName)}}
                    <!-- <div  class="price">
                      <p v-if="item.isShowChargeInfo">
                        <span class="price-amount">{{item.min}}</span>
                        <span class="price-text">{{item.minUnit || ''}} 起</span>
                      </p>
                      <span v-else>
                        价格请电话联系
                      </span>
                    </div> -->
                  </div>
                  <div class="split-tags">
                    <img src="./image/temperature_1.svg" />
                    <span v-for="(v,index) in item.chargeInfos"
                          :key="index">{{v.temperatureLayerName}}</span>
                  </div>
                  <div class="area">
                    <img src="./image/area_1.svg" />
                    <span>面积：{{item.area}}㎡</span>
                    <span>可租面积：{{item.availableArea}}㎡</span>
                  </div>
                  <div class="address">
                    <img src="./image/location-information_1.svg">
                    <div>
                      <span class="address-info">{{item.address}}</span>
                      <span class="mapBtn" @click.stop="showMap(item.id)">查看地图</span>
                    </div>
                  </div>
                  <!-- <div v-if="item.label.length" class="advantage-tags">
                    <span
                      v-for="(tag,index1) in item.label"
                      :key="index1"
                      :class="filterClass(index1)">{{tag}}</span>
                  </div> -->
                </div>
              </div>
            </div>
            <a-modal v-model="visible"
                    :footer="null"
                    @cancel="destMap()">
              <Map v-if="visible" :detail="detail" />
            </a-modal>
            <div class="pagination">
              <a-pagination
                v-model="page"
                show-quick-jumper
                show-size-changer
                :default-page-size="10"
                :total="total"
                :page-size-options="['10', '20', '50', '100']"
                @change="handlePages"
                @showSizeChange="sizechange"
              />
            </div>
          </div>
          <div v-else class="no-pic">
            <img src="@/assets/img/pic_kongde.png" alt="">
            <p>没有找到符合条件的结果</p>
          </div>
        </div>
        <!-- <div  class="advertisement">
          <div v-if="poster.length > 0" class="affixTop">
            <a-carousel autoplay>
              <div v-for="item in poster" :key="item.imgUrl">
                <a :href="item.href ? item.href : 'javascript:void(0);'">
                  <img class="imageStyle" :src="item.imgUrl" alt="">
                </a>
              </div>
            </a-carousel>
          </div>
          <a-affix :offset-top="filterWhareTop('right')" :target="() => filterDom()">
            <div class="programme">
              <img class="bgimg" src="@/assets/img/icon/pic_programme.png" alt="">
              <p class="formTitle">免费获取方案</p>
              <a-form-model ref="programmeForm" :model="form" :rules="rules" :layout="'vertical'">
                <a-form-model-item prop="contacts">
                  <a-input v-model="form.contacts" :max-length="30" placeholder="请输入您的姓名" />
                </a-form-model-item>
                <a-form-model-item prop="telPhone">
                  <a-input v-model="form.telPhone" :max-length="11" placeholder="请输入您的手机号" />
                </a-form-model-item>
                <a-form-model-item prop="area">
                  <a-input v-model="form.area" type="number" placeholder="请输入需求面积" suffix="㎡" />
                </a-form-model-item>
                <a-form-model-item prop="list">
                  <a-cascader
                    ref="cascaderDom"
                    v-model="form.list"
                    class="cascader"
                    :options="options"
                    :allow-clear="false"
                    expand-trigger="hover"
                    placeholder="请选择需求城市"
                    @change="onChange"
                  />
                </a-form-model-item>
                <a-form-model-item>
                  <a-select v-model="form.temperatureZones" placeholder="请选择温区">
                    <a-select-option v-for="item in TEMPERATURES" :key="item.value">
                      {{item.label}}
                    </a-select-option>
                  </a-select>
                </a-form-model-item>
              </a-form-model>
              <a-button v-track-click="{trackName: '我要寻仓-免费获取方案-立即获取方案'}" class="submitStyle" type="primary"  @click="onSubmit">
                立即获取方案
              </a-button>
              <p class="tips"><a-icon type="exclamation-circle" />提交后将有专属经理为您服务</p>
            </div>
          </a-affix>
        </div> -->
        <div  class="good-warehouse">
          <recommend @toDetail="toDetail" />
        </div>
      </div>
    </div>
    <map-warehouse v-else @toList="showMapWarehouse = false" />
    <!-- 委托找仓 -->
    <FindWarehouse ref="FindWarehouse" :options="options" :warehouse-list="warehouseList" />
    <Lease ref="Lease" :options="options" />
  </div>
</template>

<script>
import {
  getEntrepotType,
  getEntrepotInfo,
  getEntrepotDetails,
} from '@/api/seekWarehouse/seekWarehouse'
import { getToken } from "@/utils/auth";
import { getCityAreaTree } from "@/components/app-cascader-province/api.js";
import {postTrack} from '@/utils/point'
import { fetchRegion, programme } from './api'
import Map from './Map.vue'
import MapWarehouse from './component/MapWarehouse.vue'
import { regionalList, TEMPERATURES,yuncangList } from './constant'
import FindWarehouse from './component/FindWarehouse.vue'
import Lease from './component/Lease.vue'
import { getRosterPage } from '../login/api/auth/index'
import Recommend from './component/Recommend.vue'

const areaList = [
  {
    label: '不限',
    min: 0,
    max: '',
  },
  {
    label: '<1000m²',
    min: 0,
    max: 1000,
  },
  {
    label: '1000m²-5000m²',
    min: 1001,
    max: 5000,
  },
  {
    label: '5001m²-10000m²',
    min: 5001,
    max: 10000,
  },
  {
    label: '>10000m²',
    min: 10001,
    max: '',
  },
]
const warmAreaList = [
  {
    value: '常温',
    label: '常温库'
  },
  {
    value: '冷藏',
    label: '冷藏库'
  },
  {
    value: '冷冻',
    label: '冷冻库'
  },
  {
    value: '恒温',
    label: '恒温库'
  },
]

export default {
  name: 'SeekWarehouse',
  components: {
    Map,
    MapWarehouse,
    FindWarehouse,
    Lease,
    Recommend,
  },
  data() {
    const validatePass2 = (rule, value, callback) => {
      if (value*1 < 0 || value*1 > 99999) {
        callback(new Error('0＜面积＜99999'));
      }  else {
        callback();
      }
    };
    return {
      areaList,
      warmAreaList,
      warehouseList: [],
      provinceList: [], // '全部', '上海','贵州','云南','西藏','陕西','甘肃','青海','宁夏','新疆'
      cityList: [],
      regionList: [],
      queryForm: {
        province: '',
        city: '',
        region: '',
        area: areaList[0].label,
        warmArea: '',
        warehouse: '',
        minArea: '',
        maxArea: '',
        regional: '',
        safeEquipments:'',
        fireWareLevel:'',
        isBizService:undefined,
      },
      regionalCityList: [],
      WarehouseInfo: [],
      total: 0,
      visible: false,
      detail: {},
      page: 1,
      size: 10,
      warehouseName: '',
      showTotal: false,
      loading: false,
      showMapWarehouse: false,
      regionalList, // 区域列表
      regionalCode: [],
      top: 120,
      whareTop: 60,
      form: {
        contacts: '',
        telPhone: '',
        area: '',
        list: [],
        temperatureZones: '恒温',
        provinceCode: '',
        provinceName: '',
        cityCode: '',
        cityName: '',
        countyCode: '',
        countyName: '',
        type: 'FREE_SEARCH',
      },
      options: [],
      TEMPERATURES,
      poster: [],
      rules: {
        contacts: [
          { required: true, message: '请输入姓名', trigger: 'change' },
        ],
        telPhone: [
          { required: true, message: '请输入手机号', trigger: 'change' },
          { pattern: /^\d{1,11}$/, message: '请输入正确的手机号', trigger: 'change' },
        ],
        list: [
          { required: true, message: '请选择需要找仓城市', trigger: 'change' },
        ],
        area: [
          { validator: validatePass2, trigger: 'change' },
        ],
      },
      level: 2,
      safeEquipments:[], // 硬件设施
      warehouseFireRating:[] , // 消防等级
      yuncangList,
    }
  },
  computed: {
  },
  async created() {
    postTrack(`免费获取方案`)
    this.fetchRegion('province', ['0'])
    this.warehouseList =[{code:'',name:'不限'},...await this.getDictionaryType('WAREHOUSE_TYPE')]
    this.warehouseFireRating =[{code:'',name:'不限'},...await this.getDictionaryType('WAREHOUSE_FIRE_RATING')] 	
    this.safeEquipments =[{code:'',name:'不限'},...await this.getDictionaryType('SAFE_EQUIPMENTS')] 
    this.getEntrepotInfo();
    const options = await getCityAreaTree({
      filterBlackList: true,
    });
    this.options = this.filterData(options, 1);
  },
  mounted() {
    getRosterPage({
     configKey: 'CONSIGNOR_WEB_Poster',
    }).then(res => {
      // const records  = res[0]?.[`${bannerType}:ALL`] || {}
      // if (records.status === 'ENABLED') {
      //   this.poster = records.ext?.options
      // }
      const record  = res[0]?.configValue
      if (record) {
        const info = JSON.parse(record)?.options
        if ((!info.deadline || info.deadline > new Date().getTime())) {
          this.poster = info || {}
        }
      }
    })
  },
  methods: {
    async getDictionaryType(dictionaryCode){
      const res = await getEntrepotType({dictionaryCode})
      return res.dictionaryValues||[]
    },
    toDetail(id) {
      const link = this.$router.resolve({ path:'/detail', query: {  id,source:this.$route.query.source } }) || {};
      window.open(link.href,'_blank');
    },
    wareImage(file) {
      let img
      const res = [...file].filter((v) => v.fileType.startsWith('image'))
      if (res[0]) {
        img = res[0].filePath
      }
      return img
    },
    filterWhareTop(area){
      if(this.$route.path === '/seekWarehouse'){
        return area === 'top' ? this.whareTop : this.top
      }
      return area === 'top' ? 0 : 60
    },
    filterClass(index){
      if((index + 1) % 3 === 1){
        return ''
      }
      if((index + 1) % 3 === 2){
        return 'blue'
      }
      return 'yellow'
    },
    toFindWarehouse(){
      this.$refs.FindWarehouse.show()
    },
    toLease(){
      this.$refs.Lease.show()
    },
    async onSubmit(){
      try {
        await this.$refs.programmeForm.validate()
      } catch {
         this.$message.warning('输入不正确')
         return
      }
      programme({
        ...this.form,
        temperatureZones: [this.form.temperatureZones],
        customerCode: this.$store.state.user.customerCode,
        tenantId: this.$store.state.user.tenantId,
      }).then(()=>{
        this.$set(this, 'form',{
          contacts: '',
          telPhone: '',
          area: '',
          list: [],
          temperatureZones: '恒温',
          provinceCode: '',
          provinceName: '',
          cityCode: '',
          cityName: '',
          countyCode: '',
          countyName: '',
          type: 'FREE_SEARCH',
        })
        this.$notification.open({
          message: '您的需求发布成功',
          description:
            '您的专属经理将尽快与你联系',
          icon: <a-icon type="check-circle" style="color: #25c48d" />,
        });
      })
    },
    onChange(value, selectedOptions){
      this.form.provinceCode =  selectedOptions[0].areaCode
      this.form.provinceName =  selectedOptions[0].areaName
      this.form.cityCode =  selectedOptions[1].areaCode
      this.form.cityName =  selectedOptions[1].areaName
      this.form.countyCode =  selectedOptions[2].areaCode
      this.form.countyName =  selectedOptions[2].areaName
    },
    filterData(data, level) {
      data.forEach((e) => {
        e.label = e.areaName;
        e.value = e.areaCode;
        if (level === this.level) {
          e.children = null;
        }
        if (level <= this.level && e.children && e.children.length > 0) {
          this.filterData(e.children, level + 1);
        }
      });
      return data;
    },
    filterDom(){
      return document.getElementById('popContainer')
    },
    // 搜索
    onSearch() {
      this.queryForm = {
        province: '',
        city: '',
        region: '',
        area: areaList[0].label,
        warmArea: '',
        warehouse: '',
        minArea: '',
        maxArea: '',
        regional: '',
      }
      this.page = 1
      this.cityList = []
      this.regionList= []
      this.showTotal = true
      this.getEntrepotInfo();
    },
    getEntrepotInfo(page, size) {
      postTrack('我要寻仓-仓库列表')
      this.loading = true
      const { province, city, region, warehouse, warmArea, minArea, maxArea,safeEquipments,fireWareLevel,isBizService } = this.queryForm
      this.page = page || this.page;
      this.size = size || this.size; 
      const { warehouseName, regionalCode } = this
      getEntrepotInfo({
        provinceCodes: province ? [province] : regionalCode || [],
        cityCodes: (city && [city]) || [],
        countyCodes: (region && [region]) || [],
        temperatureLayer: {
          temperatureLayerName: warmArea,
        },
        type: warehouse,
        minArea,
        maxArea,
        warehouseName,
        safeEquipments,
        fireWareLevel,
        isBizService:isBizService?Number(isBizService):undefined,
      },{
        page: this.page,
        size: this.size,
      }
      ).then((res) => {
        this.loading = false
        this.total = res.total
        res.records.map(rec => {
          const item = rec
          let min = 0;
          let max = 0;
          let minUnit = '';
          let maxUnit = '';
          (item.chargeInfos || []).forEach(charge => {
            if (charge.price > max) {
              max = charge.price
              maxUnit = charge.unit
            }
            if (!min || min > charge.price) {
              min = charge.price
              minUnit = charge.unit
            }
          })
          item.min = min
          item.max= max
          item.minUnit = minUnit
          item.maxUnit = maxUnit
          return item
        })
        this.WarehouseInfo = res.records
        this.showTotal = true
      })
    },
    areaChange(item){
      this.queryForm.area = item.label
      this.queryForm.minArea = item.min
      this.queryForm.maxArea = item.max
      this.handleQueryList()
    },
    warmChange(item){
      if(item){
         this.queryForm.warmArea = item.value
      }else{
        this.queryForm.warmArea = ''
      }
      this.handleQueryList()
    },
    queryListStyle(val) {
      return val ? 'query-btn active' : 'query-btn'
    },
    warehouseChange(item){
      this.queryForm.warehouse = item.code
      this.handleQueryList()
    },
    handleChange(item,prop,itemProp='value'){
      this.queryForm[prop] = item[itemProp]
      this.handleQueryList()
    },
    nameDispose(name) {
      return !String(name).substring(16)
        ? name
        : `${String(name).substring(0, 15)}...`
    },
    handleQueryList() {
      this.page = 1;
      this.warehouseName = ''
      this.showTotal = false
      this.getEntrepotInfo();
    },
    handleProvince(attr, val, item) {
      // this.regionalCode = []
      this.queryForm[attr] = val
      if (!this.queryForm.province) {
        this.cityList = []
        this.queryForm.city = ''
        this.queryForm.region = ''
      }
      if (!this.queryForm.city) {
        this.regionList = []
        this.queryForm.region = ''
      }
      if (attr === 'regional') {
        const code = []
        const provinceList = item?.provinceList || []
        this.provinceList.forEach((province) => {
          if (provinceList.includes(province.label)) {
            code.push(province.code)
          }
        })
        this.cityList = []
        this.regionList = []
        this.queryForm.province = ''
        this.queryForm.city = ''
        this.queryForm.region = ''
        this.showTotal = false
        this.regionalCode = code
      }
      // this.handleQueryList()
      switch (attr) {
        case 'regional':
          this.regionalCityList = item?.provinceList || []
          this.handleQueryList()
          break
        case 'province':
          this.fetchRegion('city', [val])
          break
        case 'city':
          this.fetchRegion('region', [val])
          break
        case 'region':
          this.handleQueryList()
          break
        default:
          this.regionalCityList = []
          break
      }
    },
    handlePages(page, size) {
      this.showTotal = false
      this.getEntrepotInfo(page, size)
    },
    sizechange(page, size) {
      this.showTotal = false
      this.getEntrepotInfo(page, size)
    },
    fetchRegion(attr, val) {
      const data = {
        parentCodes: val, // 父级编码
        filterBlackList: true
      }
      fetchRegion(data).then((res) => {
        // 省份需要去掉后4个
        // if (attr === 'province') {
        //   res.splice(res.length - 4)
        // }
        const arr = res.map((e) => {
          return {
            code: e.areaCode,
            label: e.areaName,
          }
        })
        if (arr.length > 0) {
          // arr.unshift({ label: '全部', code: '' })
          this[`${attr}List`] = arr
        }
        switch (attr) {
          case 'city':
            this.regionList = []
            this.queryForm.region = ''
            if(arr.length === 1) {
              const { code } = arr[0]
              this.queryForm.city = code
              this.fetchRegion('region', [code])
            } else {
              this.queryForm.city = ''
              this.handleQueryList()
            }
            break
          case 'region':
            this.queryForm.region = ''
            this.handleQueryList()
            break
          default:
            break
        }
      })
    },
    viewDetail(id) {
      let link = {}
      if(this.$route.query.source==='WMS'){
        link =this.$router.resolve({ path:'/detail', query: {  id,source:this.$route.query.source } }) || {};
      }else if (getToken()) {
        link =this.$router.resolve({ path:'/seekWarehouse/detail', query: {  id } }) || {};
      } else {
        link =this.$router.resolve({ path:'/detail' }) || {};
      }
      window.open(link.href,'_blank');
    },
    async showMap(id) {
      const res = await getEntrepotDetails({ id })
      this.detail = res || {}
      this.visible = false
      this.$nextTick(() => {
        this.visible = true
      })
    },
    destMap() {
      this.visible = false
    },
  },
}
</script>

<style lang="less" scoped>
::v-deep .checkbox .ant-checkbox-checked .ant-checkbox-inner{
  background-color: #059E84;
  border-color: #059E84;
}
.SeekWarehouse-root {
  // margin: 0 30px 30px 30px;
  .title-seek {
    display: flex;
    justify-content: space-between;
    margin-bottom: 10px;
    align-items: flex-end;
    padding-bottom: 10px;
    background-color: #F6F8Fa;
    .map-warehouse {
      color: #646566;
      font-size: 12px;
      display: flex;
      flex-direction: column;
      margin-left: 16px;
      background-image: url('../../assets/img/icon_map_warehouse.png');
      background-repeat: no-repeat;
      background-position: 14px 0;
      background-size: 20px;
      span {
        margin-top: 24px;
      }
      &:hover {
        color: #06B880;
        background-image: url('../../assets/img/icon_map_warehouse_hover.png');
      }
    }
    .find{
      width: 228px;
      height: 48px;
      background: #FFFFFF;
      border-radius: 6px;
      display: flex;
      span{
        display: inline-block;
        width: 50%;
        height: 24px;
        line-height: 24px;
        padding-left: 10px;
        box-sizing: border-box;
        font-size: 14px;
        color: #171717;
        margin-top: 12px;
        &:hover{
          color: #06B880;
          cursor: pointer;
        }
      }
      span:nth-child(1){
        border-right: 1px solid #DCDEE0;
      }
    }
  }
  .breadcrumb {
    font-size: 20px;
    font-weight: bold;
    color: #171717;
    display: flex;
  }
  .seek-search {
    width: 463px;
    ::v-deep .ant-input {
      border-radius: 24px;
      border: 1px solid #E7E9EC;
      height: 36px;
      color: #171717;
      &:focus {
        box-shadow: none;
      }
    }
    &:hover {
      ::v-deep .ant-input-suffix {
        .anticon-search {
          color: #06B880;
        }
      }
    }
  }
  .search-total {
    margin-left: 16px;
    color: #059E84;
    font-size: 13px;
    font-weight: 400;
    line-height: 20px;
    display: flex;
    align-items:center;;
  }
  .query-box {
    background: #fff;
    width: 100%;
    border-radius: 4px;
    padding: 10px 20px;
    .query-list {
      display: flex;
      &:not(:last-child) {
        border-bottom: 1px dashed #f1f1f1;
      }
      .query-title {
        // padding: 16px 20px 16px 0;
        width: 100px;
        margin-right: 30px;
        font-weight: 400;
        display: flex;
        box-sizing: border-box;
        justify-content: center;
        align-content: center;
        line-height: 60px;
        padding-top: 10px;
        text-align: right;
        background-repeat: no-repeat;
        background-position: 40px 10px;
        background-size: 20px 20px;
        color: #1C2026;
        font-size: 14px;
      }
      .query-weizhi {
        background-image: url('./image/location-information.svg');
      }
      .query-wuqu {
        background-image: url('./image/temperature.svg');
      }
      .query-area {
        background-image: url('./image/area.svg');
      }
      .query-type {
        background-image: url('./image/warehouse.svg');
      }
      .query-Fire{
         background-image: url('./image/fire.svg');
      }
      .query-hardware{
        background-image: url('./image/sheshi.svg');
      }
      .query-yuncang{
        background-image: url('./image/yongyingshang.svg');
      }

      .query-body {
        display: flex;
        flex: 1;
        flex-wrap: wrap;
        padding: 20px 0 10px 0;
        .weizhi-list {
          flex: 1;
        }
        .query-btn {
          box-sizing: border-box;
          margin-right: 25px;
          padding: 2px 8px;
          height: 24px;
          margin-bottom: 10px;
          border-radius: 4px;
          cursor: pointer;
          display: inline-block;

          &:hover {
            color: #06b880;
          }
          &:active {
            color: #029869;
          }
          &.active {
            background: #059E84;
            color: #fff;
          }
        }
      }
    }
  }
  .no-pic {
    text-align: center;
    color: #606266;
    img {
      width: 248px;
      height: 248px;
      margin: 56px 0 24px;
    }
  }
  .body-box {
    width: 100%;
    .body-list {
      width: 100%;
      padding: 32px 24px;
      height: 225px;
      display: flex;
      background: #fff;
      overflow: hidden;
      border-bottom: 1px solid #EBEDF0;
      &:hover {
        background: #e6f7f2;
      }
      .btn {
        padding: 0 10px;
        height: 22px;
        font-size: 12px;
        margin-top: 2px;
        .anticon {
          margin-left: 2px;
        }
      }
      .img-box {
        width: 224px;
        height: 168px;
        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          border-radius: 6px;
        }
      }
      .detail-box {
        flex: 1;
        width: calc(100% - 224px);
        padding: 0 8px 0 32px;
        .name {
          color: #272727;
          display: flex;
          justify-content: space-between;
          font-size: 16px;
          font-weight: bold;
          margin-bottom: 16px;
        }
        .split-tags {
          span {
            position: relative;
            font-size: 14px;
            padding: 0 14px 0 8px;
            &:first-of-type {
              padding-left: 0px;
            }
            &:not(:last-child):after {
              content: '';
              width: 2px;
              height: 70%;
              background-color: #C0C4CC;
              position: absolute;
              left: 90%;
              top: 4px;
            }
          }
        }
        .split-tags, .area, .address {
          margin-bottom: 6px;
          align-items: center;
          img {
            width: 16px;
            height: 16px;
            margin-right: 4px;
          }
        }
        .area span {
          padding: 0 14px 0 8px;
          position: relative;
          &:first-of-type {
            padding-left: 0px;
          }
          &:first-of-type::after {
            content: '';
            width: 2px;
            height: 70%;
            background-color: #C0C4CC;
            position: absolute;
            right: 0;
            top: 4px;
          }
        }
        .advantage-tags {
          margin-top: 8px;
          margin-bottom: 12px;
          overflow: hidden;
          white-space: nowrap;
          span {
            margin-right: 4px;
            border-radius: 2px;
            background: #e4fdf5;
            font-size: 12px;
            padding: 5px 10px;
            color: #06b880;
          }
          .blue{
            background: rgba(79, 151, 229, 0.15);
            color: #4F97E5;
          }
          .yellow{
            background: rgba(251, 148, 50, 0.2);
            color: #FB9432;
          }
        }
        .price {
          span {
            color: #ED4934;
            font-size: 16px;
          }
          .price-amount {
            font-size: 24px;
            font-weight: bold;
          }
          .price-text{
            color: #606266;
            font-size: 12px;
          }
        }
        .address {
          display: flex;
          width: 100%;
          align-items: flex-start;
          img{
            margin-top: 3px;
          }
          > div {
            // display: flex;
            width: 100%;
          }
          .address-info {
            display: inline-block;
            max-width: 60%;
            padding: 0;
            margin: 0;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            flex: 1;
          }
          .mapBtn{
            vertical-align: super;
            font-size: 12px;
            color: #06B880;
            line-height: 22px;
            margin-left: 32px;
            &:hover{
              cursor: pointer;
            }
          }
        }
      }
      .right-box {
        width: 160px;
        padding-top: 10px;

        .btn {
          margin-top: 80px;
          width: 120px;
        }
      }
    }
  }
  .pagination {
    padding-top: 40px;
    text-align: right;
    padding-right: 32px;
  }
}
.bodyDiv{
  display: flex;
  position: relative;
}
.advertisement{
  width: 30%;
  margin-top: 24px;
}
.bodyLeft{
  width: 80%;
  background: #fff;
  padding: 0 0 56px 0;
  margin-top: 24px;
  margin-right: 24px;
}
.body-content {
  background-color: #fff;
  display: block;
  flex-wrap: wrap;
  @media screen and (max-width: 1920px)  {
    div:nth-of-type(3n) {
      margin-right: 0px !important;
    }
  }
  @media screen and (min-width: 1921px)  {
    div:nth-of-type(4n) {
      margin-right: 0px !important;
    }
  }
}
.programme /deep/.ant-select-selection {
  background-color: #e9ebf0;
  border: 1px solid transparent;
}
/deep/.ant-modal {
  width: 60% !important;
}
.FindWarehouse /deep/ .ant-modal {
  width: 800px !important;
}
.Lease /deep/ .ant-modal {
  width: 800px !important;
}
/deep/ .ant-affix{
  z-index: 1000 !important;
}
.affixTop{
  width: 100%;
  // height: 320px;
  overflow: hidden;
  border-radius: 6px;
  margin-bottom: 24px;
  /deep/ .ant-carousel .slick-slide {
    text-align: center;
    height: 320px;
    line-height: 320px;
    background: #364d79;
    overflow: hidden;
  }
  /deep/ .ant-carousel .slick-slide img{
    height: 320px;
  }
  /deep/ .ant-carousel .slick-slide h3 {
    color: #fff;
  }
}
.programme{
  width: 100%;
  padding: 32px;
  background-color: #fff;
  position: relative;
  .bgimg{
    width: 225px;
    height: 104px;
    position: absolute;
    top: 0;
    right: 0;
  }
  /deep/ .ant-input{
    background: #F4F5F6;
  }
  /deep/.ant-select-selection {
    background-color: #F4F5F6;
    border: 1px solid #ccc;
  }
  .cascader{
    background: #F4F5F6;
  }
  .tips{
    i{
      margin-right: 8px;
    }
  }
}
.submitStyle{
  height: 48px;
  width: 100%;
}
.tips{
  width: 100%;
  text-align: center;
  font-size: 14px;
  color: #909399;
  margin-top: 14px;
}
.formTitle{
  position:relative;
  font-size: 24px;
  color: #171717;
  font-weight: bold;
  margin-bottom: 30px;
}
.imageStyle{
  width: 100%;
  height: 100%;
}
.good-warehouse {
  margin-top: 24px;
  position: absolute;
  top: 0;
  bottom: 0;
  right: 0;
  width: calc(21% - 24px);
}
</style>  
<style lang="less">
.auth-container {
  .SeekWarehouse-root {
    margin-top: 0;
    // padding-top: 56px;
  }
  @media screen and (min-width: 1681px) {
    .SeekWarehouse-root {
      // padding-top: 56px;
    }
  }
}
</style>
